function e(e,...r){return r.reduce(((e,r,c)=>e.replace(`{${c}}`,r)),e)}export{e as genMsg};
